/*
 * Free shipping bar - currency conversion.
 *
 * The free-shipping discounts are defined in the shop currency (EUR). Liquid has no
 * access to the FX rate, so a shop-currency threshold cannot be shown correctly in a
 * converted currency from Liquid alone. Shopify exposes its own live rate on the
 * storefront as Shopify.currency.rate, which is the same rate it uses to convert
 * prices, so we use that rather than hardcoding anything.
 *
 * This is a custom element on purpose. Dawn re-renders the cart sections by replacing
 * innerHTML, and an inline <script> injected that way never executes - but a custom
 * element upgrades itself whenever it is inserted, so connectedCallback runs again on
 * every cart update.
 *
 * When the cart currency equals the shop currency (rate 1) this does nothing at all and
 * the server-rendered Liquid output stands, keeping Shopify's own money formatting.
 */
(function () {
  if (customElements.get('lm-ship-bar')) return;

  class LmShipBar extends HTMLElement {
    connectedCallback() {
      try {
        this.update();
      } catch (e) {
        // Never let a formatting problem hide the cart. Fall back to the Liquid output.
        this.removeAttribute('hidden');
      }
    }

    update() {
      // Over the free-shipping weight cap: Liquid's note has no amounts, leave it as is.
      if (this.dataset.heavy === 'true') {
        this.removeAttribute('hidden');
        return;
      }

      const rate = parseFloat(
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1'
      );
      const shopCents = parseInt(this.dataset.thresholdShop, 10);
      const cartCents = parseInt(this.dataset.cartTotal, 10);

      if (!shopCents || isNaN(cartCents)) {
        this.removeAttribute('hidden');
        return;
      }

      // Same currency as the shop: Liquid already rendered the correct figure.
      if (!rate || Math.abs(rate - 1) < 0.000001) {
        this.removeAttribute('hidden');
        return;
      }

      const threshold = Math.round(shopCents * rate);
      const remaining = Math.max(threshold - cartCents, 0);
      const qualified = remaining <= 0;

      let pct = threshold > 0 ? Math.floor((cartCents * 100) / threshold) : 0;
      if (pct > 100) pct = 100;
      if (pct < 3 && !qualified) pct = 3;

      const textEl = this.querySelector('.lm-ship__copy');
      const fillEl = this.querySelector('.lm-ship__fill');

      if (fillEl) fillEl.style.width = pct + '%';

      if (textEl) {
        if (qualified) {
          textEl.textContent = this.dataset.msgDone || '';
        } else {
          const tpl = this.dataset.msgRemaining || '';
          const money = this.formatMoney(remaining);
          textEl.innerHTML = this.escape(tpl).replace(
            '{{amount}}',
            '<strong class="lm-ship__amount"></strong>'
          );
          const strong = textEl.querySelector('.lm-ship__amount');
          if (strong) strong.textContent = money;
        }
      }

      this.classList.toggle('lm-ship--done', qualified);
      const wrap = this.querySelector('.lm-ship');
      if (wrap) wrap.classList.toggle('lm-ship--done', qualified);

      this.removeAttribute('hidden');
    }

    formatMoney(cents) {
      const currency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      const locale = document.documentElement.lang || 'en';
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }

    escape(str) {
      const d = document.createElement('div');
      d.textContent = str;
      return d.innerHTML;
    }
  }

  customElements.define('lm-ship-bar', LmShipBar);
})();
